import React from 'react';
import { Chip } from '@mui/material';
import {
  ErrorOutline as ErrorOutlineIcon,
  ReportProblemOutlined as ReportProblemOutlinedIcon,
} from '@mui/icons-material';

export interface SeverityBadgeProps {
  severity?: string | null;
}

const severityStyles = (severity: string) => {
  const value = severity.toLowerCase();
  if (value === 'critical') {
    return { bgcolor: '#8f1d1d', color: '#fff', borderColor: '#7f1d1d', height: 32, icon: <ErrorOutlineIcon sx={{ fontSize: 17 }} /> };
  }
  if (value === 'high') {
    return { bgcolor: '#b42318', color: '#fff', borderColor: '#912018', height: 32, icon: <ErrorOutlineIcon sx={{ fontSize: 17 }} /> };
  }
  if (value === 'medium') {
    return { bgcolor: '#f6c453', color: '#1f2937', borderColor: '#e4b93d', height: 30, icon: <ReportProblemOutlinedIcon sx={{ fontSize: 16 }} /> };
  }
  if (value === 'low') return { bgcolor: '#dbe7f3', color: '#1f2937', borderColor: '#c6d3e1', height: 28, icon: undefined };
  return { bgcolor: '#eceff3', color: '#4b5563', borderColor: '#d4dae3', height: 28, icon: undefined };
};

const SeverityBadge: React.FC<SeverityBadgeProps> = ({ severity }) => {
  const label = String(severity || 'unknown').toUpperCase();
  const styles = severityStyles(String(severity || 'unknown'));
  return (
    <Chip
      size="small"
      label={label}
      icon={styles.icon as any}
      sx={{
        height: styles.height,
        borderRadius: 999,
        bgcolor: styles.bgcolor,
        color: styles.color,
        fontWeight: 900,
        letterSpacing: 0.35,
        border: '1px solid',
        borderColor: styles.borderColor,
        boxShadow: label === 'HIGH' || label === 'CRITICAL' ? '0 2px 8px rgba(127, 29, 29, 0.18)' : 'none',
        '& .MuiChip-label': { px: 1.1 },
        '& .MuiChip-icon': { color: styles.color, ml: 0.7 },
      }}
    />
  );
};

export default SeverityBadge;
